import { StartTacoMatch as DLStart, ResetTacoMatch as DLReset, ShowTacoFrontPage as DLShowFrontPage } from './../DL/Tacos';
import SignalRService from '../WS/SignalRService';

let tacoPlayerMessageHandler = null;
let tacoPlayerReconnectedHandler = null;
let tacoAdminMessageHandler = null;
let tacoAdminReconnectedHandler = null;

// ==========================================================================
// 🔌 SIGNALR (Dedicado a Taco 1v1)
// ==========================================================================
export const ConnectTacoWebSocket = async (playerId, roomId, onStatus = () => {}, onToast = () => {}) => {
    onStatus('connecting');

    tacoPlayerReconnectedHandler = () => {
        onStatus('connected');
    };

    SignalRService.on('reconnected', tacoPlayerReconnectedHandler);

    SignalRService.connect({ tipo: `taco:${playerId}`, roomId: roomId || '' })
        .then(() => {
            onStatus('connected');
            onToast('Conectado a la taquería 🌮');
        })
        .catch((err) => {
            console.error("[TacosWS] Error al conectar a SignalR:", err);
            onStatus('error');
        });
};

export const SetTacoSocketMessageHandler = (handler) => {
    if (tacoPlayerMessageHandler) {
        SignalRService.off('message', tacoPlayerMessageHandler);
    }

    tacoPlayerMessageHandler = (envelope) => {
        handler(envelope);
    };

    SignalRService.on('message', tacoPlayerMessageHandler);
};

export const ClearTacoSocketMessageHandler = () => {
    if (tacoPlayerMessageHandler) {
        SignalRService.off('message', tacoPlayerMessageHandler);
        tacoPlayerMessageHandler = null;
    }
};

export const DisconnectTacoWebSocket = () => {
    if (tacoPlayerMessageHandler) {
        SignalRService.off('message', tacoPlayerMessageHandler);
        tacoPlayerMessageHandler = null;
    }
    if (tacoPlayerReconnectedHandler) {
        SignalRService.off('reconnected', tacoPlayerReconnectedHandler);
        tacoPlayerReconnectedHandler = null;
    }
    SignalRService.disconnect();
};

// ==========================================================================
// 📡 REST API (Envío de Taps en Lotes)
// ==========================================================================
const SendTacoTaps = async ({ matchId, playerId, taps }) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/Tap`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ matchId, playerId, amount: taps })
        });
        return { success: response.ok };
    } catch (error) {
        return { success: false };
    }
};

const ShowTacoFrontPageBL = async () => {
    return await DLShowFrontPage();
};


//=== Admin ===//
const StartTacoGame = async (configData) => {
    if (configData.durationSeconds < 5) return { success: false, message: "El tiempo mínimo es 5 segundos." };
    return await DLStart(configData);
};

const ResetTacoGame = async () => {
    return await DLReset();
};

const ConnectWebSocketForTacoAdmin = (onIncomingMessage, onStatusChange = () => {}, roomId = '') => {
    onStatusChange('connecting');

    tacoAdminMessageHandler = (envelope) => {
        if (envelope && envelope.type && envelope.type.startsWith('taco.')) {
            onIncomingMessage(envelope);
        }
    };

    tacoAdminReconnectedHandler = () => {
        onStatusChange('connected');
    };

    SignalRService.on('message', tacoAdminMessageHandler);
    SignalRService.on('reconnected', tacoAdminReconnectedHandler);

    SignalRService.connect({ tipo: 'superadmin', roomId: roomId || '' })
        .then(() => {
            onStatusChange('connected');
        })
        .catch((err) => {
            console.error("[TacosAdminWS] Error al conectar a SignalR:", err);
            onStatusChange('error');
        });
};

const DisconnectWebSocketForTacoAdmin = () => {
    if (tacoAdminMessageHandler) {
        SignalRService.off('message', tacoAdminMessageHandler);
        tacoAdminMessageHandler = null;
    }
    if (tacoAdminReconnectedHandler) {
        SignalRService.off('reconnected', tacoAdminReconnectedHandler);
        tacoAdminReconnectedHandler = null;
    }
    SignalRService.disconnect();
};
//=== Admin ===//

const EmergencyKickTacoPlayers = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/EmergencyKick`, { 
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        
        if (response.ok) {
            return { success: true, message: 'Jugadores desconectados.' };
        } else {
            return { success: false, message: 'No se pudo ejecutar la expulsión.' };
        }
    } catch (error) {
        return { success: false, message: 'Error de red al intentar expulsar jugadores.' };
    }
};

export { SendTacoTaps, ShowTacoFrontPageBL, StartTacoGame, ResetTacoGame, ConnectWebSocketForTacoAdmin, DisconnectWebSocketForTacoAdmin, EmergencyKickTacoPlayers };